import { Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import WarningIcon from "@material-ui/icons/Warning";
import React from "react";
import useStyles from "./ReservationResultStatusStyles";

export type ReservationResultStatusVariant = "success" | "error" | "warning";

interface ReservationResultStatusProps {
  variant: ReservationResultStatusVariant;
  title: string;
  description: string;
}

type TitleClassKey = "successTitle" | "errorTitle" | "warningTitle";

const variantIcon: Record<ReservationResultStatusVariant, React.ReactNode> = {
  success: <CheckIcon />,
  error: <CloseIcon />,
  warning: <WarningIcon />,
};

const titleClassByVariant: Record<ReservationResultStatusVariant, TitleClassKey> = {
  success: "successTitle",
  error: "errorTitle",
  warning: "warningTitle",
};

export const ReservationResultStatus = ({
  variant,
  title,
  description,
}: ReservationResultStatusProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={`${classes.iconCircle} ${classes[variant]}`}>
        <span className={classes.icon}>{variantIcon[variant]}</span>
      </div>
      <div className={classes.texts}>
        <Typography className={`${classes.title} ${classes[titleClassByVariant[variant]]}`}>
          {title}
        </Typography>
        <Typography className={classes.description}>{description}</Typography>
      </div>
    </div>
  );
};
